import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import styled from "styled-components";
import {RiAccountCircleFill, RiAddBoxLine, RiCloseFill, RiUserAddLine} from "react-icons/ri";
import {setAlert} from "../../Redux/actions/alertAction";
import {loadUser} from "../../Redux/actions/authAction";
import axios from "axios";
import {addToGroupRoute, createNewGroupRoute, getUserFriendsRoute, getUserGroupsRoute} from "../../utils/apiRoutes";
import PuffLoader from "react-spinners/PuffLoader";
import multiavatar from "@multiavatar/multiavatar/esm";
import {selectGroup} from "../../Redux/actions/contactAction";

const Groups = ({selectGroup, setAlert, socket, user, loadUser}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [userGroups, setUserGroups] = useState(null);
    const [groupIndex, setGroupIndex] = useState(null);
    const [createGroupPanel, setCreateGroupPanel] = useState(false);
    const [avatarCodes, setAvatarCodes] = useState(null);
    const [selectedAvatar, setSelectedAvatar] = useState(null);
    const [addGroupPanel, setAddGroupPanel] = useState(false);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [friends, setFriends] = useState(null);
    const [friendsLoading, setFriendsLoading] = useState(true);
    const [formData, setFormData] = useState({
        displayName: '',
        groupName: '',
    });
    const {displayName, groupName} = formData;

    useEffect(() => {
        async function fetchData() {
            await getUserGroups();
        }

        fetchData();
    }, []);

    const getUserGroups = async () => {
        try {
            setIsLoading(true);
            const res = await axios.get(getUserGroupsRoute);
            setUserGroups(res.data);
            setIsLoading(false);
        } catch (err) {
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) => setAlert(error.msg, 'error'));
            }
        }
    }

    useEffect(() => {
        async function fetchData() {
            await getUserGroups();
        }

        fetchData();
        setIsLoading(false);
    }, []);

    useEffect(() => {
        async function fetchData() {
            await getUserGroups();
        }

        if (!!socket && socket.current) {
            socket.current.on("msg-receive", (data) => {
                if (!!data)
                    fetchData();
            });
        }
    });

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!selectedAvatar) {
            setAlert('Group image not selected', 'error')
            return;
        }
        if (formData.displayName.trim().length === 0) {
            setAlert('Display name is empty', 'error')
            return;
        }
        if (formData.groupName.trim().length === 0) {
            setAlert('Group name is empty', 'error')
            return;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify({...formData, 'groupImage': selectedAvatar});

        try {
            const res = await axios.post(createNewGroupRoute, body, config);
            setCreateGroupPanel(false);
            setAlert(res.data.msg, 'success');

        } catch (err) {
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) => setAlert(error.msg, 'error'));
            }
        }
    };

    const onChange = (e) =>
        setFormData({...formData, [e.target.name]: e.target.value});

    const createNewGroup = () => {
        setSelectedAvatar(null);
        setFormData({
            displayName: '',
            groupName: '',
        })
        getAvatars();
        setCreateGroupPanel(!createGroupPanel);
    }
    const getAvatars = async () => {
        setIsLoading(true);
        const imageCodes = [];
        for (let i = 0; i < 3; i++) {
            const imageCode = Math.round(Math.random() * 1000);
            imageCodes.push(imageCode);
        }
        setAvatarCodes(imageCodes);
        setIsLoading(false);
    }

    const addGroupPanelToggle = async (groupId) => {
        //get all friends

        if (!addGroupPanel) {
            try {
                setFriendsLoading(true);
                const res = await axios.get(getUserFriendsRoute);
                setFriends(res.data);
                setFriendsLoading(false);
            } catch (err) {
                const errors = err.response.data.errors;
                if (errors) {
                    errors.forEach((error) => setAlert(error.msg, 'error'));
                }
            }
        }

        setSelectedGroupId(groupId);
        setAddGroupPanel(!addGroupPanel);
    }

    const addFriendToGroup = async (friendId) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify({groupId: selectedGroupId, friendId: friendId});

        try {
            const res = await axios.post(addToGroupRoute, body, config);
            setAlert(res.data.msg, 'success');
        } catch (err) {
            const errors = err.response.data.errors;
            if (errors) {
                errors.forEach((error) => setAlert(error.msg, 'error'));
            }
        }

        setAddGroupPanel(false);
    }

    const groupsToShow = (group, index) => {
        return (
            <div className='card-container' key={index}>
                <div onClick={() => {
                    setGroupIndex(index);
                    selectGroup(group);
                }} className={`account-container ${groupIndex === index ? "account-container-selected" : null}`}>
                    <div>
                        {
                            group.group_image ?
                                <div className='avatar avatar-icon'
                                     dangerouslySetInnerHTML={{__html: multiavatar(group.group_image)}}>
                                </div>
                                :
                                <RiAccountCircleFill className='avatar-icon'/>
                        }
                    </div>
                    <div className="account-detail-container">
                        <h4>{group.display_name}</h4>
                        <p>{group.group_name}</p>
                    </div>

                </div>

                {group.creator_id !== user.id ? null :
                    <div className='add-group-icon' onClick={() => addGroupPanelToggle(group.id)}>
                        <RiAddBoxLine/>
                    </div>
                }
            </div>
        )
    }

    const accountsToShow = (contact, index) => {
        return (
            <div key={index} onClick={() => {
                addFriendToGroup(contact.id)
            }}>
                <div
                    className='account-container'>
                    <div>
                        {
                            contact.avatarImage ?
                                <div className='avatar avatar-icon'
                                     dangerouslySetInnerHTML={{__html: multiavatar(contact.avatarImage)}}>
                                </div>
                                :
                                <RiAccountCircleFill className='avatar-icon'/>
                        }
                    </div>
                    <div className="account-detail-container">
                        <h4>{contact.name}</h4>
                        <p>{contact.email}</p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <Container>
            <div style={{paddingTop: 20}}>
                <div className='header'>
                    <h3>Groups</h3>
                </div>

                <div className='create-group-container'>
                    <div className='form-input-container' onClick={() => createNewGroup()}>
                        <RiUserAddLine onClick={() => onSubmit()} className='form-input-icon'/>
                        <p className='form-input'>Create Group</p>
                    </div>
                    {!createGroupPanel ? null :
                        <div className='select-container'>
                            <div className='select-box'>
                                <div className='profile-container'>
                                    <label className="label">Group image</label>
                                </div>

                                <div>
                                    {!isLoading ?
                                        avatarCodes.map((avatar, index) => {
                                            return (
                                                <div key={index}
                                                     className={`avatar ${selectedAvatar === avatar ? 'avatar-select' : null}`}
                                                     onClick={() => setSelectedAvatar(avatar)}
                                                     dangerouslySetInnerHTML={{__html: multiavatar(avatar)}}>
                                                </div>
                                            );
                                        })
                                        :
                                        <div className='spinner-container'><PuffLoader color="#7269EF"/></div>
                                    }
                                </div>
                                <form className='form' onSubmit={(e) => onSubmit(e)}>
                                    <div className='profile-container'>
                                        <div>
                                            <label className="label">Display name</label>
                                            <input
                                                type='text'
                                                className='form-input'
                                                name='displayName'
                                                value={displayName || ''}
                                                onChange={(e) => onChange(e)}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div>
                                            <label className="label">Group name (unique)</label>
                                            <input
                                                type='text'
                                                className='form-input'
                                                name='groupName'
                                                value={groupName || ''}
                                                onChange={(e) => onChange(e)}
                                                autoComplete="off"
                                            />
                                        </div>

                                        <input className='sign-button' type='submit' value='Create Group'/>
                                    </div>
                                </form>
                            </div>
                        </div>}
                </div>

                <div>
                    <h4>My Groups</h4>
                </div>
            </div>

            <div className="all-accounts-container">
                {
                    isLoading || !userGroups ?
                        <div className='spinner-container'><PuffLoader color="#7269EF"/></div>
                        :
                        userGroups.length > 0 ?
                            userGroups.map((group, index) =>
                                groupsToShow(group, index)
                            )
                            :
                            <p>No accounts to show!</p>
                }
            </div>

            {!addGroupPanel ? null :
                <div className='add-group-panel'>
                    <div className='add-group-close' onClick={() => setAddGroupPanel(false)}>
                        <RiCloseFill/>
                    </div>
                    <div style={{marginTop: 20, overflowY: "auto"}}>
                        {
                            friendsLoading ?
                                <div className='spinner-container'><PuffLoader color="#7269EF"/></div>
                                :
                                friends.length > 0 ?
                                    friends.map((friend, index) =>
                                        accountsToShow(friend, index)
                                    )
                                    :
                                    <p>No accounts to show!</p>
                        }
                    </div>
                </div>}
        </Container>

    );
}

Groups.propTypes = {
    selectGroup: PropTypes.func.isRequired,
    loadUser: PropTypes.func.isRequired,
    contacts: PropTypes.array,
    socket: PropTypes.object,
    user: PropTypes.object
};

const mapStateToProps = (state) => ({
    contacts: state.contact.contacts,
    setAlert: PropTypes.func.isRequired,
    socket: state.auth.socket,
    user: state.auth.user,
});

export default connect(mapStateToProps, {selectGroup, setAlert, loadUser})(Groups);

const Container = styled.div`
  background-color: #F5F7FB;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 0px 8px;
  border-left: #ECEDF6 solid 2px;
  border-right: #ECEDF6 solid 2px;
  position: relative;

  @media screen and (max-width: 1000px) {
    .header {
      margin-top: 59px;
    }
  }

  .form-input-container {
    position: relative;
    display: flex;
    cursor: pointer;
    align-items: center;
    background-color: #E6EBF5;

  }

  .header {
    padding: 12px 16px 24px 16px;
  }

  .create-group-container {
    position: relative;
    padding: 0 16px 24px 16px;

    .select-container {
      position: relative;
    }

    .select-box {
      margin-top: 10px;
      margin-top: 10px;
      background-color: #fff;
      position: absolute;
      z-index: 1;
      border-radius: 0.5rem;

      .avatar {
        width: 5rem;
        padding: 0px !important;
        margin: 10px;
        display: inline-block;
        cursor: pointer;
      }

      .avatar-select {
        border: 5px #7269EF solid;
        border-radius: 50%;
      }
    }

    p {
      background-color: #E6EBF5;
    }
  }

  .form-input-icon {
    color: #7a7f9a;
    padding: 0.5rem 0.8rem;
    font-size: 1.5rem;
    line-height: 1.5;
    white-space: nowrap;
    background-color: #E6EBF5;
    border: 1px solid #e6ebf5;
    border-radius: 0.25rem;
  }

  .form-input {
    width: 100%;
    margin-left: -1px;
    padding: 0.5rem 0;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #7a7f9a;
    background-color: #E6EBF5;
    border: 1px solid #e6ebf5;
    border-bottom-right-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .contact {
    padding: 20px 0;
    transition: 0.25s;
  }

  .isSelected {
    background-color: red !important;
  }

  .card-container {
    position: relative;

    .new-message-dot {
      color: darkRed;
      textAlign: "right";
      position: absolute;
      right: 15px;
      top: 30px
    }

    .add-group-icon {
      position: absolute;
      right: 25px;
      top: 18px;
      font-size: 1.5rem;
      padding: 10px;
      color: #878A92;
      cursor: pointer;

      :hover {
        color: #7269EF;
      }
    }
  }

  .all-accounts-container {
    position: relative;
    margin-top: 20px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0.2rem;

      &-thumb {
        background-color: #D1D6DB;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
  }

  .account-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.5s;
    margin-top: 2px;
    margin-bottom: 2px;
    border-radius: 0.5rem;

    :hover {
      background-color: #E6EBF5;
    }
  }

  .account-detail-container {
    display: flex;
    flex-direction: column;
  }

  .avatar {
    width: 2.3rem;
    padding: 16px !important;
  }

  .avatar-icon {
    font-size: 40px;
    padding: 15px;
  }

  .account-container-selected {
    background-color: #E6EBF5;
  }

  .remove-search-container {
    display: flex;
    justify-content: space-between;

    .close-icon {
      font-size: 25px;
      cursor: pointer;
    }
  }

  .spinner-container {
    display: flex;
    justify-content: center;
    padding-top: 25px;
    overflow: hidden;
    height: 100px;
  }

  .profile-container {
    background-color: white;
    padding: 20px 20px;
    font-size: 0.9rem;

    div {
      padding-bottom: 25px;
    }

    > div:last-child {
      padding-bottom: 0;
    }

    .label {
      display: block;
      margin-bottom: 0.3rem;
      color: #7A7FB3;
    }

    h4 {
      font-weight: 500;
    }

    .sign-button {
      width: 100%;
      margin-top: 1rem;
      cursor: pointer;
      color: #fff;
      background-color: #7269ef;
      line-height: 1.5;
      padding: 0.65rem 1rem;
      border-radius: 0.25rem;
      border: none;
      transition: 0.25s;
      font-size: 0.9rem;

      :hover {
        background-color: #6159cb;
        border-color: #5b54bf;
      }
    }
  }

  .form-input {
    width: calc(100% - 1rem);
    padding: 0.25rem 0.5rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #7a7f9a;
    background-color: #f5f7fb;
    border: 1px solid #e6ebf5;
    border-bottom-right-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .add-group-panel {
    position: absolute;
    top: 185px;
    width: 96%;
    background-color: #E6EBF5;
    z-index: 1;
    border-radius: 0.5rem;

    @media (max-width: 1000px) {
      width: 99%;
    }
    
    .add-group-close{
      position: absolute;
      right: 0px;
      font-size: 20px;
      padding: 15px;
      border-radius: 0.5rem;
      cursor: pointer;
      color: #878A92;
    }
  }

  .hidden {
    display: none !important;
  }
`;